import { OrdersModel } from '@pukka/api';
import { numberUtils, stringUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

import { compareTaxGratuityName } from './utils';

type PaymentGratuity = OrdersModel.OrderGratuity;
type PaymentTax = OrdersModel.OrderTax;
type PaymentTaxGratuity = PaymentTax | PaymentGratuity;

const ordering = (obj: (PaymentGratuity | PaymentTax)[]) => {
  return obj.sort(compareTaxGratuityName);
};

interface ReceiptTaxGratuityProps {
  data: PaymentTaxGratuity[];
  includeGratuityTax?: boolean;
}

function ReceiptTaxGratuity({ data, includeGratuityTax }: ReceiptTaxGratuityProps) {
  return (
    <div>
      {ordering(data).map((obj) => (
        <div key={obj.uuid} className="flex justify-between py-1">
          <Text variant="body-1">
            {stringUtils.limitTo(obj.name, 20)}
            {obj.name.length > 20 ? '...' : ' '}
            {includeGratuityTax && <span>(Included)</span>}
            {!includeGratuityTax && <span>({obj.amount}%)</span>}
          </Text>
          <Text variant="body-1" className="w-36 text-right">
            {includeGratuityTax ? '' : numberUtils.formatCurrency(obj.total, 'Rp.')}
          </Text>
        </div>
      ))}
    </div>
  );
}

export default ReceiptTaxGratuity;
